import { useAppSelector } from "store/hooks";
import style from "./TableBody.module.scss";
import { RiLoader5Fill } from "react-icons/ri";
import { useGetUserPurchaseHistoryQuery } from "@RTKQuery/admin/customers/customers";
import { useParams } from "react-router-dom";
import { IUserPurchaseHistoryRecord } from "@interfaces/admin/userPurchaseHistoryRecord";

export function TableBody({
    children
}: {
    children: (data: IUserPurchaseHistoryRecord) => JSX.Element
}) {
    const { id } = useParams();

    const { activePaginationLimit, activePaginationPage } = useAppSelector(state => state.customerHistoryAdminPage);

    const { currentData: data, isFetching, isError, refetch } = useGetUserPurchaseHistoryQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        user_id: Number(id)
    }, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true
    });

    return (
        <div className={style.body}>
            {
                isFetching && !data
                    ? <div className={style.empty} role="status" aria-label="Завантаження історії"><RiLoader5Fill className="animate-spin w-[30px] h-[30px]" /></div>
                    : isError
                        ? <div className={style.empty} role="alert">
                            <p>Не вдалося завантажити історію покупок.</p>
                            <button className="text-[#1075D4] underline mt-[10px]" onClick={() => refetch()}>Спробувати ще раз</button>
                        </div>
                        : data?.purchases_history.length
                            ? data.purchases_history.map(row => children(row))
                            : data?.count_items === 0
                                ? <p className={style.empty}>Історія покупок порожня.</p>
                                : null
            }
        </div>
    )
}

